/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespTradeOnApprovalCoachmarkLoader_user$ref: FragmentReference;
export type PdpRespTradeOnApprovalCoachmarkLoader_user = {|
  +serviceId: ?string,
  +$refType: PdpRespTradeOnApprovalCoachmarkLoader_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespTradeOnApprovalCoachmarkLoader_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '520265f1673aea4fb5900e1e20a9d5d9';
module.exports = node;
